import React from 'react'
import PropTypes from 'prop-types'
import { get, isEmpty, sortBy } from 'lodash'
import classNames from 'classnames'

import { MENU_TYPES } from '../../utils/menuTypes'
import { roleInfo } from '../../utils/employeeRoles'

import Section from '../Section'

const StaffList = ({
  attendantSettings,
  attendantStatusFilterValue,
  data,
  getEmployeeRole,
  history,
}) => {
  const sortedData = sortBy(data, 'name')

  const filterAttendantsByStatus = () => {
    switch (attendantStatusFilterValue) {
      case 'active':
        return sortedData.filter((attendant) => attendant.deactivatedAt === null)

      case 'inactive':
        return sortedData.filter((attendant) => attendant.deactivatedAt !== null)

      default: // return all attendants
        return sortedData
    }
  }

  const renderAttendant = (attendant) => {
    const employeeRole = getEmployeeRole(attendant)
    const menuTypes = get(attendantSettings, `${attendant.uuid}.configuration.menuSubtypes`)
    const { email, name, number, uuid } = attendant
    const className = classNames('attendant')
    const role = roleInfo?.[employeeRole?.role]?.name

    const displayMenuTypes = () => {
      if (menuTypes === null) return 'all'

      return sortBy(menuTypes?.map(type => MENU_TYPES[type])).join(", ")
    }

    return (
      <div
        key={uuid}
        className={className}
        onClick={() => {
          history.push(`/staff/${uuid}`)
        }}
      >
        <div className='row'>
          <div className="attendant-info-wrapper">
            <span className='name'>{name}</span>
            {email && <span>{` - ${email}`}</span>}
            {number && <span>{` - ${number}`}</span>}
          </div>
          <span className='role'>{role}</span>
          <span className='menu-types'>{displayMenuTypes()}</span>
        </div>
      </div>
    )
  }

  if (isEmpty(data)) return null

  return (
    <Section className='attendant-list'>
      {filterAttendantsByStatus().map(renderAttendant)}
    </Section>
  )
}

StaffList.defaultProps = {
  attendantSettings: {},
  data: [],
  getEmployeeRole: () => {},
}

StaffList.propTypes = {
  attendantSettings: PropTypes.object,
  data: PropTypes.array,
  getEmployeeRole: PropTypes.func,
}

export default StaffList
